<div class="ic1-col-12">
  <button
    type="button"
    class="allert-badge"
    (click)="openMigrationModal()">
    <img class="user-details-icon" src="assets/images/info-icon.svg" />
    <div [innerHTML]="'MIGRATION_PAGE.BANNER.INFO' | translate"></div>
  </button>
</div>

<app-common-modal
  modalId="migration-modal"
  [title]="'MIGRATION_PAGE.BANNER.MODAL_INFO.BUTTON' | translate"
  [(visible)]="migrationModalVisible"
  [config]="{ size: 'lg', persistent: true, hideButtons: true }"
  (onClose)="onToggleMigrationModal(false)">
  <app-migration></app-migration>
</app-common-modal>

<app-common-modal
  modalId="migration-message-modal"
  [(visible)]="migrationMessageModalVisible"
  [config]="{ size: 'md', persistent: true, hideButtons: true }"
  (onClose)="onToggleMigrationMessageModal(false)">
  <!-- START INFO MODAL -->
  <div class="modal-content">
    <div [ngClass]="'icon-' + modalMessageType">
      <img
        class="user-details-icon icon-settings"
        [id]="modalMessageType"
        [src]="'assets/images/' + modalMessageType + '-icon.svg'" />
    </div>
    <h2>
      <div
        class="title content"
        [translate]="
          'MIGRATION_PAGE.BANNER.MODAL_' + modalMessageTypeUpperCase + '.TITLE'
        "></div>
    </h2>
    <div
      class="description content"
      [translate]="
        'MIGRATION_PAGE.BANNER.MODAL_' +
        modalMessageTypeUpperCase +
        '.DESCRIPTION'
      "></div>
    <div class="button-info content">
      <ng-ui-kit-button
        (onClick)="openMigrationModal(true)"
        color="primary"
        [label]="'MIGRATION_PAGE.BANNER.MODAL_INFO.BUTTON' | translate"
        type="button"
        size="sm">
      </ng-ui-kit-button>
    </div>
  </div>
</app-common-modal>
